import * as React from 'react';

import { cn } from '@/lib/utils';

function resolveInputMode(
  type: string | undefined,
  name: string | undefined,
  inputMode: React.InputHTMLAttributes<HTMLInputElement>['inputMode'],
): React.InputHTMLAttributes<HTMLInputElement>['inputMode'] {
  if (inputMode) return inputMode;
  if (type !== 'number') return undefined;
  const n = (name ?? '').toLowerCase();
  if (/price|amount|cost|tax|rate|total|subtotal|discount/.test(n)) return 'decimal';
  if (/quantity|stock|threshold|count/.test(n)) return 'numeric';
  return 'numeric';
}

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, inputMode, name, ...props }, ref) => {
    const resolvedInputMode = resolveInputMode(type, name, inputMode);

    return (
      <input
        type={type}
        inputMode={resolvedInputMode}
        name={name}
        className={cn(
          'flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-1 text-base sm:text-sm transition-all file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-400 focus-visible:outline-none focus-visible:border-secondary-500 focus-visible:ring-2 focus-visible:ring-secondary-500/30 focus-visible:bg-white disabled:cursor-not-allowed disabled:opacity-50 dark:border-charcoal-700 dark:bg-charcoal-900 dark:placeholder:text-slate-500 dark:focus-visible:bg-charcoal-900',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
